export enum Endpoints {
  SAVE_SHIPPING_INFO = '/guest/shipping/cart-ship',
  CREATE_SHIPPING_INFO = '/guest/add/cart-add',
  GET_BUNDLES = '/guest/bundle/accessories',
  GET_PAYURL = '/guest/cart/payurl',
  CREATE_GUEST_USER = '/guest/user-create',
  GET_ACCESSORIES = '/guest/accessories',
  GET_GUEST_CART = '/guest/get/cart-get',
  GET_GUEST_PRODUCT_BRANDS = '/guest/brands/products',
  GET_GUEST_PRODUCTS = '/guest/product',
  REMOVE_USER_CART = '/guest/remove/cart-remove',
  GET_GUEST_PRODUCT_FORMULATION = '/guest/formulation/products',
  GET_GUEST_PRODUCT_CONDITIONS = '/guest/conditions/products',
}
